import React from 'react';
import styled from 'styled-components';
import {setThousandSeparator} from '../../../util/utils';
import CommonInput from './CommonInput';
import NumberFormat from 'react-number-format';
import {useSelector} from 'react-redux';
import {positiveIntegerNoSpecialCharRegex} from '../../../util/uiconstants';

function NumericInput({
	autoFocus,
	disabled,
	id,
	name,
	label,
	maxLength,
	minLength,
	onAccept,
	onBlur,
	onCancel,
	onChange,
	onFocus,
	pattern,
	placeholder,
	progressBarClassName,
	progressBarLabel,
	required,
	showLabel,
	value
}) {
	const userPreferences = useSelector((state) => state.userPreferences);

	return (
		<StyledNumericInput className="StyledNumericInput">
			<CommonInput
				autoFocus={autoFocus}
				disabled={disabled}
				id={id}
				name={name}
				label={label}
				maxLength={maxLength}
				onAccept={onAccept}
				onCancel={onCancel}
				onChange={onChange}
				onBlur={onBlur}
				onFocus={onFocus}
				maxLenght={maxLength}
				minLength={minLength}
				placeholder={placeholder}
				progressBarClassName={progressBarClassName}
				progressBarLabel={progressBarLabel}
				type="text"
				required={required}
				pattern={pattern}
				showLabel={showLabel}
				value={value}
			>
				<NumberFormat value={value} {...setThousandSeparator(userPreferences.numberFormat)} />
			</CommonInput>
		</StyledNumericInput>
	);
}

NumericInput.defaultProps = {
	pattern: positiveIntegerNoSpecialCharRegex
};

export default NumericInput;

const StyledNumericInput = styled.section``;
